export const geoFetch = async <T>(url: string, key?: string): Promise<T> => {
    const res = await fetch(url);
    const parsedRes = await res.json();
    const data = parsedRes.data;

    return key ? data[key] : data;
};
